import { MenuListItem } from '@/store/modules/menu'
import { HOME_PATH } from '@/config/home'

const DEFAULT_HOME_ROUTE = '/'

/**
 * 解析最终首页：
 * 1) 配置为 "/" 直接返回；
 * 2) 配置有权限返回配置路径；
 * 3) 否则回退到默认首页。
 */
export const resolveDefaultHomePath = (
  pageList: MenuListItem[] = []
) => {
  // 统一清洗路径：去掉 hash/query，确保权限比较一致
  const normalizePath = (path = '') => path.split('#')[0].split('?')[0] || ''

  // 读取配置首页；未配置时默认回到 "/"
  const configuredPath = typeof HOME_PATH === 'string' && HOME_PATH.trim()
    ? HOME_PATH.trim()
    : DEFAULT_HOME_ROUTE

  if (configuredPath === DEFAULT_HOME_ROUTE) return DEFAULT_HOME_ROUTE

  const target = normalizePath(configuredPath)
  const hasPermission = pageList.some(page => normalizePath(page.routeUrl) === target)
  return hasPermission ? configuredPath : DEFAULT_HOME_ROUTE
}
